import { useEffect, useState } from 'react';
import './RefCode.css';
import '../components/About.css';
import { useTranslation } from 'react-i18next';

const REF_STORAGE_KEY = 'refCode';

/*
 * Код приглашения приходит в двух форматах ссылок:
 *   /ref?uid=<код>          — Android и веб-кошелёк (myRefCode с бэкенда);
 *   /auth/signup?ref=<код>  — iOS (AuraShareLinks.signup).
 * Если в адресе кода нет, берём сохранённый при прошлом заходе.
 */
function readRefCode() {
  const params = new URLSearchParams(window.location.search);
  const fromUrl = (params.get('uid') ?? params.get('ref') ?? '').trim();

  try {
    if (fromUrl) {
      window.localStorage.setItem(REF_STORAGE_KEY, fromUrl);
      return fromUrl;
    }
    return window.localStorage.getItem(REF_STORAGE_KEY) || null;
  } catch {
    return fromUrl || null;
  }
}

export const RefCode = () => {
  const { t } = useTranslation('landing');
  const [open, setOpen] = useState(false);

  // Один раз пробуем открыть установленное приложение. Раньше переход стоял
  // прямо в теле компонента и повторялся на каждом рендере (в т.ч. при
  // открытии модалки), а без кода уходил как ref=null.
  useEffect(() => {
    const code = readRefCode();
    if (!code) return;
    window.location.href = `aura://auth/signup?ref=${encodeURIComponent(code)}`;
  }, []);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  const openApple = () => {
    window.location.href = `https://apps.apple.com/ru/app/aura-vibe/id6737061162`;
  };

  const downloadApk = () => {
    window.location.href = `https://aura-vibe.site/aura.apk`;
  };

  return (
    <div className="login-page refferal-page">
      <div className="content">
        <div className="welcome-section">
          <img src="/aura-logo.png" className="logo" alt="Aura" />

          <h1 className="welcome-title">
            <span>Aura</span>
          </h1>

          <div className="welcome-description">Маркетплейс для своих</div>

          <div className="about__buttons">
            <button type="button" className="about__button" onClick={() => openApple()}>
              <img
                src="/apple_icon.png"
                alt=""
                className="about__button-icon about__button-icon--apple"
              />
              <span>AppStore</span>
            </button>
            <button
              type="button"
              className="about__button"
              onClick={() => setOpen(true)}
            >
              <img src="/google_icon.png" alt="" className="about__button-icon" />
              <span>Google Play</span>
            </button>
            <button
              type="button"
              className="about__button"
              onClick={() => setOpen(true)}
            >
              <img src="/rustore_icon.png" alt="" className="about__button-icon" />
              <span>RuStore</span>
            </button>
            <button
              type="button"
              className="about__button"
              onClick={() => downloadApk()}
            >
              <img src="/android.png" alt="" className="about__button-icon" />
              <span>Скачать APK</span>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div
          className="modal"
          role="dialog"
          aria-modal="true"
          onClick={() => setOpen(false)}
        >
          <div className="modal__card" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="modal__close"
              aria-label={t('modal.close')}
              onClick={() => setOpen(false)}
            >
              &times;
            </button>
            <img src="/aura-logo.png" alt="" className="modal__mark" />
            <h3 className="modal__title">{t('modal.title')}</h3>
            <p className="modal__text">{t('modal.text')}</p>
            <button
              type="button"
              className="modal__button"
              onClick={() => setOpen(false)}
            >
              {t('modal.close')}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
